import { DayPicker, type DayPickerProps, Popover } from "@overmap-ai/blocks"
import { type ComponentPropsWithoutRef, memo } from "react"

export type DayPickerPopoverProps = DayPickerProps &
	ComponentPropsWithoutRef<typeof Popover.Root> &
	Pick<ComponentPropsWithoutRef<typeof Popover.Content>, "align">

export const DayPickerPopover = memo<DayPickerPopoverProps>((props) => {
	const { children, open, onOpenChange, defaultOpen, modal, size, align, accentColor = "base", ...rest } = props

	return (
		<Popover.Root open={open} onOpenChange={onOpenChange} defaultOpen={defaultOpen} modal={modal}>
			<Popover.Trigger asChild>{children}</Popover.Trigger>
			<Popover.Content size={size} align={align}>
				<DayPicker size={size} autoFocus accentColor={accentColor} {...rest} />
			</Popover.Content>
		</Popover.Root>
	)
})
DayPickerPopover.displayName = "DayPickerPopover"
